import React from 'react';
export default ({ currencies, selectedCurrencyCode, onCurrencySelected }) => {
    if (!currencies) {
        return null;
    }
    return (
        <ul>
            {currencies.map((currency, index) => (
                <li
                    key={index}
                    className={`multi-currency-item ${
                        selectedCurrencyCode === currency.code ? 'selected' : ''
                    }`}
                    onClick={onCurrencySelected(currency)}>
                    <div className="multi-currency-unit-title-short">
                        {currency.shortName}
                    </div>
                    <div className="multi-currency-unit-title-long">
                        {currency.longName}
                    </div>
                </li>
            ))}
        </ul>
    );
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/multi-currency/multi-currency-list.jsx